import * as angular from "angular";
import {IController, ILogService} from "angular";
import {LogisticsVehicleStatusType} from "../../types/logistics-vehicle-status.type";
import {LogisticsVehicleService} from "../../services/logistics-vehicle-service.service";
import {LogisticsVehicle} from "../../models/logistics-vehicle.model";
import {LogisticsVehiclesDialogsService} from "../../services/logistics-vehicles-dialogs-service.service";
import {
  VehicleStatusChangeReasonSettingsEntity
} from "../../../site-preferences/models/vehicle-status-change-reason-settings.model";

export class LogisticsVehicleStatusSelectCtrl implements IController {

  logisticsVehicle: LogisticsVehicle;
  isLarge: boolean;
  loading: boolean;
  isDisabled: boolean;
  isOutline: boolean;
  onChangeStatus: Function;



  public options: typeof LogisticsVehicleStatusType = LogisticsVehicleStatusType;

  /* @ngInject */
  constructor(private $log: ILogService, private logisticsVehicleService: LogisticsVehicleService, private logisticsVehiclesDialogsService: LogisticsVehiclesDialogsService) {

  }

  $onInit() {
    this.loading = false;
  }

  $onChanges(changes) {

  }



}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehicleStatusSelect', {
    bindings: {
      logisticsVehicle: '<?',
      isLarge: '<?',
      loading: '<?',
      isDisabled: '<?',
      isOutline: '<?',
      onChangeStatus: '&'
    },
    template: require('./logistics-vehicle-status-select.html').default,
    controller: LogisticsVehicleStatusSelectCtrl
  });

